import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import dayjs from "dayjs";
import Switch from "@mui/material/Switch";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

import {
  titleFormStyle,
  titleDownload,
  itemList,
  titleItem,
  subMail,
  boxNotiContent,
  container,
  groupList,
  boxNotiIcon,
  boxButton,
  groupBoxContent,
  boxFlex,
  datetimeInput,
  subTitleFormStyle,
  wrapEditorStyle,
  wrapInputStyle,
} from "./style";

import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDEditor from "components/MDEditor";
import { SVGIcon } from "components/icons";
import MDButton from "components/MDButton";
import {
  useCreatePushNotiScheduleMutation,
  useUploadFileSendNotiMutation,
  useUploadByTypeMutation,
} from "shared/redux/endpoints/notifications";
import MDBox from "components/MDBox";
import { useCreatePushNotiMutation } from "shared/redux/endpoints/notifications";
import { useSearchParams } from "react-router-dom";
// import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon";
import { NotificationTarget } from "constant/NotificationType";
import MDSelect from "components/MDSelect";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ToastUtil } from "utilities/toastUtil";

const FormNotification = (props) => {
  // eslint-disable-next-line react/prop-types
  const { dataTemplate, target, recipient, onSubmit = () => {} } = props;

  const [formData, setFormData] = useState({
    lxoIds: [],
    teacherIds: [],
    centerIds: [],
    startDate: null,
    endDate: null,
    englishTitle: "",
    englishBody: "",
    vietnameseTitle: "",
    vietnameseBody: "",
    targetOfCenter: NotificationTarget.TEACHERS,
  });

  const [errors, setErrors] = useState({});
  const [listIdSend, setListIdSend] = useState([]);
  const [openSuccessSB, setOpenSuccessSB] = useState(false);
  const [bodyEnglish, setBodyEnglish] = useState("");
  const [bodyVietnamese, setBodyVietnamese] = useState("");
  const [isSchedule, setIsSchedule] = useState(false);
  const [keyRender, setKeyRender] = useState(0);

  useEffect(() => {
    if (dataTemplate) {
      const dataTemplateDetail = dataTemplate?.data;

      setFormData({
        ...formData,
        englishTitle: dataTemplateDetail?.titleEn,
        englishBody: dataTemplateDetail?.contentEn,
        vietnameseTitle: dataTemplateDetail?.titleVi,
        vietnameseBody: dataTemplateDetail?.contentVi,
      });

      setBodyEnglish(dataTemplateDetail?.contentEn);
      setBodyVietnamese(dataTemplateDetail?.contentVi);
    }
  }, [dataTemplate]);

  useEffect(() => {
    setTimeout(() => {
      setKeyRender(1);
    }, 1000);
  }, []);

  const [createNotificationSchedule, { isLoading, data, error, isSuccess }] =
    useCreatePushNotiScheduleMutation();

  const [createNotifications] = useCreatePushNotiMutation();

  const [
    uploadFile,
    {
      isLoading: loadingUpload,
      isSuccess: isSuccessUpload,
      data: dataUpload = {},
    },
  ] = useUploadByTypeMutation();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const validateFields = (data) => {
    const errors = {};

    // Validate DatePickers
    const startDate = data.startDate;

    if (isSchedule) {
      if (!startDate) {
        errors.startDate = "Field is required";
      } else if (dayjs(startDate).isBefore(dayjs(), "day")) {
        errors.startDate = "Start date must be today or later";
      }
    }

    if (listIdSend.length === 0) {
      errors.listIdSend = "Please upload file to send";
    }

    // Validate tiêu đề và nội dung cho tiếng Anh
    if ((!data.englishTitle || data.englishTitle.trim() === "") && !id) {
      errors.englishTitle = "Field is required";
    }

    if ((!bodyEnglish || bodyEnglish.trim() === "") && !id) {
      errors.englishBody = "Field is required";
    }

    // Validate tiêu đề và nội dung cho tiếng Việt
    if ((!data.vietnameseTitle || data.vietnameseTitle.trim() === "") && !id) {
      errors.vietnameseTitle = "Field is required";
    }

    if ((!bodyVietnamese || bodyVietnamese.trim() === "") && !id) {
      errors.vietnameseBody = "Field is required";
    }

    return errors;
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // const handleOpenSuccess = () => setOpenSuccessSB(true);
  // const handleCloseSuccess = () => setOpenSuccessSB(false);

  // const renderSuccessSB = (
  //   <MDSnackbar
  //     color="success"
  //     icon="check"
  //     title="Notification"
  //     content="Data has been successfully sent! You have successfully pushed the notification."
  //     open={openSuccessSB}
  //     onClose={handleCloseSuccess}
  //     close={handleCloseSuccess}
  //     bgWhite
  //   />
  // );

  const handleSubmit = () => {
    const validationErrors = validateFields(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formSubmit = {
      centerIds: formData.centerIds,
      lxoIds: formData.lxoIds,
      teacherIds: formData.teacherIds,
      ...(isSchedule && {
        scheduleTime: dayjs(formData.startDate).format(
          "YYYY-MM-DD HH:mm:ss.SSS"
        ),
      }),
      sendAll: false,
      ...(id
        ? { useTemplate: true, templateId: id }
        : {
            notification: {
              status: "UNREAD",
              notificationContentEntity: {
                target: target,
                ...(target === NotificationTarget.CENTERS && {
                  targetIds: formData.centerIds,
                }),
                titleVi: formData.vietnameseTitle,
                titleEn: formData.englishTitle,
                contentVi: bodyVietnamese,
                contentEn: bodyEnglish,
                template: false,
                coverUrl:
                  "https://tudylab.s3.ap-southeast-1.amazonaws.com/static/jenkins_start.png",
                notificationType: "ANNOUNCEMENT",
              },
            },
          }),
      targetOfCenter: formData.targetOfCenter,
    };

    if (isSchedule) {
      createNotificationSchedule(formSubmit).then((data) => {
        if (data?.data?.status) {
          ToastUtil.showToastSuccess("Schedule created successfully");
        } else {
          ToastUtil.showToastError("Schedule created failed");
        }
      });
    } else {
      createNotifications(formSubmit).then((data) => {
        if (data?.data?.status) {
          ToastUtil.showToastSuccess("Notification created successfully");
        } else {
          ToastUtil.showToastError("Notification created failed");
        }
      });
    }
    onSubmit && onSubmit();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", target);

    uploadFile(formData).then((data) => {
      if (data?.data?.status) {
        const validItems = data?.data?.data || [];
        if (data) {
          setListIdSend(validItems.map((item) => item.id));

          if (target === NotificationTarget.CENTERS) {
            setFormData((prev) => ({
              ...prev,
              centerIds: validItems.map((item) => item.id),
            }));
          } else if (target === NotificationTarget.LXOS) {
            setFormData((prev) => ({
              ...prev,
              lxoIds: validItems.map((item) => item.id),
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              teacherIds: validItems.map((item) => item.id),
            }));
          }
        }
      }
    });
  };

  const handleFileUpload = () => {
    document.getElementById("file-upload").click();
  };

  const handleDownload = () => {
    const link = document.createElement("a");

    link.download = "example_upload_notification_users.csv";
    if (target === NotificationTarget.CENTERS) {
      link.download = "example_upload_notification_centers.csv";
    }
    link.href = `/${link.download}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <MDBox sx={container}>
      {id && (
        <MDTypography sx={titleFormStyle} my={1.5}>
          Template selected: <u>{id}</u>
        </MDTypography>
      )}

      <MDBox sx={boxFlex}>
        <MDBox className="box-item">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MDBox display="flex" alignItems="center">
              <MDTypography sx={subTitleFormStyle}>Set schedule:</MDTypography>
              <Switch
                checked={isSchedule}
                onChange={(e) => setIsSchedule(e.target.checked)}
              />
            </MDBox>
            <MDBox className="box-item-input">
              <DateTimePicker
                sx={datetimeInput}
                disabled={!isSchedule}
                // label="With Time Clock"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                minDateTime={dayjs().add(1, "hour")}
                onChange={(newValue) =>
                  handleInputChange("startDate", newValue)
                }
              />
              {errors.startDate && (
                <MDTypography fontSize="12px" color="error" mt={1}>
                  {errors.startDate}
                </MDTypography>
              )}
            </MDBox>
          </LocalizationProvider>
        </MDBox>

        <MDBox className="box-item">
          <MDBox display="flex" alignItems="center">
            <MDTypography
              sx={(theme) => ({
                ...subTitleFormStyle(theme),
                ...(!(target === NotificationTarget.CENTERS) && {
                  opacity: 0.7,
                }),
              })}
            >
              Send notification to
            </MDTypography>
            <Switch
              sx={{ opacity: 0, visibility: "hidden" }}
              checked={isSchedule}
              onChange={(e) => setIsSchedule(e.target.checked)}
            />
          </MDBox>
          <MDBox className="box-item-input">
            <MDSelect
              // value={formData.targetOfCenter}
              isDisabled={!(target === NotificationTarget.CENTERS)}
              options={[
                { value: NotificationTarget.ALL, label: "All" },
                { value: NotificationTarget.TEACHERS, label: "Teachers" },
                { value: NotificationTarget.LXOS, label: "LXOs" },
              ]}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, targetOfCenter: e.value }));
              }}
              placeholder="Select target of center"
              className={`select ${
                !(target === NotificationTarget.CENTERS) && "select-disabled"
              }`}
            ></MDSelect>
          </MDBox>
        </MDBox>

        <MDBox className="box-item">
          <MDBox>
            <input
              accept=".csv"
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              hidden
            />
            <MDTypography
              variant="label"
              htmlFor="file-upload"
              sx={(theme) => ({
                ...subTitleFormStyle(theme),
                gap: 0,
                "&:hover": {
                  textDecoration: "underline",
                },
              })}
              onClick={handleDownload}
            >
              <FileDownloadOutlinedIcon />
              <span>Download sample</span>
            </MDTypography>
          </MDBox>
          <MDButton
            sx={(theme) => ({
              ...titleDownload(theme),
            })}
            onClick={handleFileUpload}
          >
            Upload file here <SVGIcon name="upload" sx={{ ml: 3 }} />
          </MDButton>
        </MDBox>
      </MDBox>

      {errors.listIdSend && (
        <MDTypography fontSize="12px" color="error">
          {errors.listIdSend}
        </MDTypography>
      )}

      <MDBox sx={groupList}>
        {dataUpload?.data?.map((item) => {
          return (
            <MDBox sx={itemList} key={item.id}>
              <MDTypography sx={titleItem}>{item.value}</MDTypography>
              <MDTypography sx={subMail}>{item.id}</MDTypography>
            </MDBox>
          );
        })}
      </MDBox>
      <MDTypography sx={titleFormStyle} mt={3}>
        Notification content
      </MDTypography>
      <MDBox sx={boxNotiContent} position="relative">
        <MDBox sx={groupBoxContent}>
          <MDTypography sx={subTitleFormStyle} mt={2}>
            English title
          </MDTypography>
          <MDBox mt={1}>
            <MDInput
              name="englishTitle"
              labelType="non-sticky"
              error={!!errors.englishTitle}
              value={formData.englishTitle}
              onChange={(e) =>
                handleInputChange("englishTitle", e.target.value)
              }
              placeholder="Set an English title here"
              size="large"
              sx={(theme) => ({
                width: "100%",
                ...wrapInputStyle(theme),
              })}
              success={!!formData.englishTitle}
              defaultValue={formData.englishTitle}
              disabled={!!id}
            />
          </MDBox>

          <MDBox mt={2} sx={wrapEditorStyle}>
            <MDTypography sx={subTitleFormStyle}>Body </MDTypography>
            <MDEditor
              setValue={setBodyEnglish}
              defaultValue={formData?.englishBody}
              value={bodyEnglish}
              key={keyRender}
              disabled={!!id}
              className={`md-editor ${!!id ? "disabled" : ""}`}
            />
            {errors.englishBody && (
              <MDTypography fontSize="12px" color="error">
                {errors.englishBody}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
        <MDBox sx={boxNotiIcon}>
          <SVGIcon name="arrow-left" />
          <SVGIcon name="arrow-right" />
        </MDBox>
        <MDBox sx={groupBoxContent}>
          <MDTypography sx={subTitleFormStyle} mt={2}>
            Vietnamese title
          </MDTypography>
          <MDBox mt={1}>
            <MDInput
              name="vietnameseTitle"
              labelType="non-sticky"
              error={!!errors.vietnameseTitle}
              value={formData.vietnameseTitle}
              onChange={(e) =>
                handleInputChange("vietnameseTitle", e.target.value)
              }
              placeholder="Set an Vietnamese title here"
              size="large"
              sx={(theme) => ({
                width: "100%",
                ...wrapInputStyle(theme),
              })}
              className={wrapInputStyle}
              success={!!formData.vietnameseTitle}
              defaultValue={formData?.vietnameseTitle}
              disabled={!!id}
            />
          </MDBox>
          <MDBox mt={2} sx={wrapEditorStyle}>
            <MDTypography sx={subTitleFormStyle}>Body </MDTypography>
            <MDEditor
              setValue={setBodyVietnamese}
              defaultValue={formData?.vietnameseBody}
              value={bodyVietnamese}
              key={keyRender}
              disabled={!!id}
              className={`md-editor ${!!id ? "disabled" : ""}`}
            />
            {errors.vietnameseBody && (
              <MDTypography fontSize="12px" color="error">
                {errors.vietnameseBody}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
      <MDBox mt={2} sx={boxButton}>
        <MDButton color="success" size="small" onClick={handleSubmit}>
          Send
        </MDButton>
        {/* <MDButton color="info" size="small">
          Preview
        </MDButton> */}
      </MDBox>
    </MDBox>
  );
};

FormNotification.defaultProps = {
  dataTemplate: {},
};

// Typechecking props for the FormNotification
FormNotification.propTypes = {
  dataTemplate: PropTypes.object,
};

export default FormNotification;
